<template>
  <div class="cnc-dropdown" :class="`${size}`" ref="dropdown">
    <div class="section-main" :class="{ 'is-open': isOpen }" @click="toggleDropdown">
      <div v-if="labelColor" class="title" :style="{ color: labelColor }">
        {{ labelText }}
      </div>
      <div v-else class="title">
        {{ labelText }}
      </div>
      <div class="icon">
        <CncIcon
          name="ico_chevron_down"
          :color="labelColor ? labelColor : $store.state.color['primary-500']"
        />
      </div>
    </div>
    <div v-show="isOpen"
         class="section-dropdown"
         :class="{'is-open': isOpen}"
         :style="dropdownStyle">
      <div class="option-item"
           v-for="option in options"
           :key="option.value"
           @click="selectOption(option)"
           :class="{'is-selected': getIsSelect(option)}">
        <div class="section-option-left">
          <div class="option-label">{{ option.label }}</div>
        </div>
        <div class="section-option-right">
          <CncIcon
            v-if="getIsSelect(option)"
            name="ico_check"
            :color="$store.state.color['primary-500']"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CncDropdown',
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    size: {
      type: String,
      default: 'medium'
    },
    labelColor: {
      type: String
    },
    label: {
      type: String
    }
  },

  data () {
    return {
      isOpen: false,
      val: this.value,
      dropdownStyle: {
        maxHeight: '200px',
        minWidth: '250px',
        overflowY: 'auto'
      }
    }
  },

  computed: {
    labelText () {
      if (this.label) return this.label
      const selectedOption = this.options.find(option =>
        option.value === this.val || option.id === this.val
      )
      return selectedOption ? selectedOption.label : ''
    }
  },

  watch: {
    value (newVal) {
      this.val = newVal
    },
    val (newVal) {
      this.$emit('change', newVal)
      this.$emit('update:value', newVal)
    }
  },

  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },

  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  },

  methods: {
    toggleDropdown () {
      this.isOpen = !this.isOpen
    },

    selectOption (option) {
      this.val = option.value || option.id
      this.$emit('selectOption', option)
      this.isOpen = false
    },

    getIsSelect (option) {
      return this.val === option.value || this.val === option.id
    },

    handleClickOutside (event) {
      const dropdown = this.$refs.dropdown
      if (dropdown && !dropdown.contains(event.target) && this.isOpen) {
        this.isOpen = false
      }
    }
  }
}
</script>

<style lang="scss">
.v-portal-target {
  display: block !important;
  position: relative;
  z-index: 9999;
}

.cnc-dropdown {
  position: relative;
  width: auto;
  z-index: 100;

  .section-main {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;
    transition: all 0.3s ease;
    background-color: white;

    .title {
      color: $color-primary-500;
      font-size: 16px;
      font-weight: 500;
    }

    .icon {
      transition: transform 0.3s ease;
    }

    &.is-open {
      .icon {
        transform: rotate(180deg);
      }
    }
  }

  .section-dropdown {
    display: block;
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 4px;
    background-color: white;
    border: 1px solid $color-cool-grey-100;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    padding: 8px;
    opacity: 1;
    visibility: visible;
    transform-origin: top;
    transition: all 0.2s ease;

    &:not(.is-open) {
      opacity: 0;
      visibility: hidden;
      transform: translateY(-10px);
    }

    .option-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px;
      cursor: pointer;
      border-radius: 6px;
      transition: all 0.2s ease;

      .option-label {
        color: $color-cool-grey-700;
        font-size: 14px;
      }

      &:hover {
        background-color: $color-cool-grey-50;
        background-color: $color-primary-50;
        .option-label {
          color: $color-primary-500;
        }
      }
    }
  }

  &.medium {
    .section-main .title {
      font-size: 16px;
    }
    .section-dropdown .option-label {
      font-size: 14px;
    }
  }

  &.large {
    .section-main .title {
      font-size: 20px;
    }
    .section-dropdown .option-label {
      font-size: 16px;
    }
  }
}
</style>
